import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../../PanelPage";
import {Flow} from "../../../../flows/Flow.js";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService";
import {Messages} from "../../../../../Messages";
import {LinkButton} from "../../../../../../core/ui/LinkButton.jsx";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {redirectToMerchantHomepage} from "../../../../../widget/misc/WidgetUtils";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {PaymentFailedPanelStyle} from "../../payment-method/PaymentFailedPanel";
import {SadFaceIcon} from "../../../../../../core/ui/SVGElements.jsx";
import {SubscriptionCoveragePerk} from "../../subscribe/components/CoverageDescriptionElements";
import {iFrameState} from "../../../../../services/IFrameState";
import {MessageElement} from "../../../../../widget/ui/MessageElement";
import {TNR_ALIAS} from "../../../../../../blink-sdk/Constants";
import {startDonationFlow} from "../../../../flows/FlowEntrypoint.js";


@registerStyle(PaymentFailedPanelStyle)
export class DonationCanceledPanel extends BasePanelPage {
    getGuidelines() {
        if (iFrameState.forceHideWallet) {
            return [];
        }

        const {styleSheet} = this;

        return [
            <div className={styleSheet.message}>{Messages.donationCanceledText2}</div>,
            <SubscriptionCoveragePerk text={Messages.donationCanceledGuideline1}/>,
            <SubscriptionCoveragePerk text={Messages.donationCanceledGuideline2}/>,
        ];
    }

    render() {
        const {styleSheet} = this;
        const donation = Flow.donation.previouslyCanceledDonation;
        const publicationName = iFrameMerchantService.getMerchant().name;

        return [
            !iFrameMerchantService.isMerchant(TNR_ALIAS) && <SadFaceIcon
                className={styleSheet.icon}
                color={this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR}
            />,

            <div className={styleSheet.title}>{Messages.donatePageDonationCanceledTitle}</div>,

            <MessageElement className={styleSheet.message} message={Messages.donationCanceledText1(donation.formatPrice())}/>,

            this.getGuidelines(),

            <MerchantButton onClick={redirectToMerchantHomepage} className={styleSheet.actionButton}>
                {Messages.returnToHomepage(publicationName)}
            </MerchantButton>,

            <LinkButton
                value={Messages.makeAnotherDonation}
                className={styleSheet.backButton}
                onClick={() => startDonationFlow()}
            />
        ];
    }
}
